import { render, staticRenderFns } from "./BottomNavigation.vue?vue&type=template&id=08119126&scoped=true"
import script from "./BottomNavigation.vue?vue&type=script&setup=true&lang=js"
export * from "./BottomNavigation.vue?vue&type=script&setup=true&lang=js"
import style0 from "./BottomNavigation.vue?vue&type=style&index=0&id=08119126&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08119126",
  null
  
)

export default component.exports